import { CSSProperties, ReactNode } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { Color } from '@vivli/shared/theme';
import { faExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const containerStyle = (): CSSProperties => ({
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    columnGap: '5px',
    alignItems: 'center',
});

interface GridCellErrorIconViewProps extends ICellRendererParams {
    showErrorIcon?: boolean;
    dataId?: string;
    dataTestId?: string;
    titleText?: string;
}

///note: this is specifically for cells that need to show an error icon
export const GridCellErrorIconView = ({ value, valueFormatted, showErrorIcon, dataId, dataTestId }: GridCellErrorIconViewProps): ReactNode => {
    const _value = valueFormatted || value;
    const iconColor = showErrorIcon && value?.length > 0 ? Color.VIVLI_RED : Color.TRANSPARENT;

    return (
        <div style={containerStyle()} data-test-id={dataId} data-testid={dataTestId}>
            {
                <FontAwesomeIcon
                    style={{
                        color: iconColor,
                        fontSize: '20px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        alignSelf: 'start',
                        verticalAlign: 'middle',
                        marginTop: '10px',
                    }}
                    icon={faExclamation}
                />
            }
            <div>{_value}</div>
        </div>
    );
};
